import {ChangeEvent, Dispatch, forwardRef, Ref, SetStateAction} from 'react';
import {useTranslation} from 'react-i18next';
import ICON_SMALL_CLOSE from '../../../public/static/more/icon-small-close.svg';
import Button from '../../common/component/Button';
import DescText from '../../common/component/DescText';
import SingleText from '../../common/component/SingleText';
import Text from '../../common/component/Text';
import TextButton from '../../common/component/TextButton';
import {REGION} from '../../common/constant';
import {pToast} from '../../common/container/PToast';
import useUserAgent from '../../common/hook/useUserAgent';
import {setRefs} from '../../commonSub/function';

interface IProps {
  onChangeFile: (e: ChangeEvent<HTMLInputElement>) => void;
  onClickAdd: () => void;
  setFileList: Dispatch<SetStateAction<File[] | undefined>>;
  initFileList: () => void;
  canWrite: boolean;
  fileList?: File[];
  isWebview?: boolean;
}

function InquiryFileInputV4(
  {
    onChangeFile,
    onClickAdd,
    setFileList,
    initFileList,
    canWrite,
    fileList,
    isWebview,
  }: IProps,
  ref: Ref<HTMLInputElement>
) {
  const {t} = useTranslation();
  const userAgent = useUserAgent();

  return (
    <>
      <div className="mt-8">
        <input
          className="hidden"
          onChange={onChangeFile}
          ref={el => setRefs(el, ref)}
          type="file"
          multiple
        />
        <div
          className={cn(
            'min-h-[52px] px-18 py-16 rounded-8 bg-grey-02 light:bg-white',
            {
              '!bg-transparent border border-solid border-grey-02 light:border-grey-03':
                !canWrite,
              '!border-[0.5px]': !canWrite && !!userAgent?.isIos,
            }
          )}
        >
          <div className="h-20 flex items-center justify-between">
            <Text
              className={cn('s14-regular-white light:text-black', {
                '!text-grey-03': !canWrite,
              })}
            >
              {t('more_customer_inquiry_attachment')}
            </Text>
            <TextButton
              className={cn(
                'flex-center h-26 w-41 rounded-25 bg-grey-04 light:bg-grey-02',
                'px-10 py-6',
                {
                  'opacity-20': !canWrite,
                }
              )}
              onClick={onClickAdd}
              textClassName="!whitespace-nowrap s12-medium-white light:text-black"
            >
              {t('more_customer_inquiry_attachment_button')}
            </TextButton>
          </div>
          <div>
            {fileList?.map((file, index) => (
              <div
                key={index}
                className="flex justify-between items-center mt-16 first:mt-27"
              >
                <SingleText className="flex-1 s13-regular-white light:text-black">
                  {file.name}
                </SingleText>
                <Button
                  className="ml-14 mr-2"
                  onClick={() => {
                    initFileList();
                    setFileList(
                      fileList.filter(
                        (_, filteringIndex) => filteringIndex !== index
                      )
                    );
                    pToast(t('more_customer_inquiry_file_deleted_toast'));
                  }}
                >
                  <img src={ICON_SMALL_CLOSE} alt="delete" />
                </Button>
              </div>
            ))}
          </div>
        </div>
      </div>
      <DescText
        className={cn('mt-10 mx-7 s12-regular-grey06', {
          'opacity-50': !canWrite,
        })}
      >
        {t('more_customer_inquiry_attachment_detail')}
      </DescText>
      {REGION === 'kor' && (
        <DescText
          className={cn('mt-10 mx-7 s12-regular-grey06', {
            'opacity-50': !canWrite,
          })}
        >
          {t(
            `${
              isWebview ? '첨부할 파일이 있' : '파일 첨부에 실패하'
            }는 경우, 카카오 고객센터(https://cs.kakao.com) > 카카오웹툰> [문의하기] 를 통해 접수 부탁드립니다.`,
            {nsSeparator: '|'}
          )}
        </DescText>
      )}
    </>
  );
}

export default forwardRef(InquiryFileInputV4);
